export const SEARCH_NAME_FIELD = 'search'
